"use strict";
/**
 * SSA Process Module Types
 *
 * Types for the Safety Assessment Process Module that manages:
 * - SafetyAssessment entities (process containers within projects)
 * - Work products stored in dedicated tables (SFHA, FTA, FMEA, CMA)
 * - Generated reports in DOCUMENTS table
 * - Neptune graph traceability
 *
 * This is separate from safety.ts which defines document-based types.
 * These types support the "Safety" tab within projects.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSSAId = generateSSAId;
exports.calculateCompletenessScore = calculateCompletenessScore;
exports.getPhaseDisplayName = getPhaseDisplayName;
exports.getStageDisplayName = getStageDisplayName;
// ===== Utility Functions =====
/**
 * Generate a unique SSA ID
 */
function generateSSAId(prefix) {
    const year = new Date().getFullYear();
    const timestamp = Date.now().toString(36);
    const random = Math.random().toString(36).substring(2, 6);
    return `${prefix}-${year}-${timestamp}${random}`.toUpperCase();
}
/**
 * Calculate completeness score based on work products
 */
function calculateCompletenessScore(assessment) {
    const weights = {
        sfha: 25,
        fta: 35,
        fmea: 25,
        cma: 15,
    };
    let score = 0;
    if (assessment.workProducts.sfha?.status === 'complete' ||
        assessment.workProducts.sfha?.status === 'verified') {
        score += weights.sfha;
    }
    else if (assessment.workProducts.sfha) {
        score += weights.sfha * 0.5;
    }
    if (assessment.workProducts.fta && assessment.workProducts.fta.length > 0) {
        const completeFTAs = assessment.workProducts.fta.filter(f => f.status === 'complete' || f.status === 'verified').length;
        score += (completeFTAs / assessment.workProducts.fta.length) * weights.fta;
    }
    if (assessment.workProducts.fmea?.status === 'complete' ||
        assessment.workProducts.fmea?.status === 'verified') {
        score += weights.fmea;
    }
    else if (assessment.workProducts.fmea) {
        score += weights.fmea * 0.5;
    }
    if (assessment.workProducts.cma?.status === 'complete' ||
        assessment.workProducts.cma?.status === 'verified') {
        score += weights.cma;
    }
    else if (assessment.workProducts.cma) {
        score += weights.cma * 0.5;
    }
    return Math.round(score);
}
/**
 * Get phase display name
 */
function getPhaseDisplayName(phase) {
    const names = {
        sfha: 'System Functional Hazard Assessment',
        fta: 'Fault Tree Analysis',
        fmea: 'Failure Modes and Effects Analysis',
        cma: 'Common Mode Analysis',
        report: 'Report Generation',
    };
    return names[phase];
}
/**
 * Get stage display name
 */
function getStageDisplayName(stage) {
    return stage === 'pssa' ? 'Preliminary SSA' : 'System Safety Assessment';
}
//# sourceMappingURL=ssa-types.js.map